import Full from './full.vue';
import MobFull from './mob-full.vue';

export const componentMap = {
	full: Full,
	'mob-full': MobFull
};
